export function getSendHomeRequestMessage(facilityName?: string): string {
  return `Your sent home request has been sent to ${
    facilityName ? `${facilityName}` : "the workplace"
  }. We will update this channel once we have a response.`;
}
